/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import { Language } from 'components/lib/DesignSystem/Icons'

import Protection from '../icons/Protection'
import {
  AttackVectorContainer,
  AttackVectorDescription,
  AttackVectorSubTitle,
  AttackVectorSubTitleContainer,
  AttackVectorTitle,
  AttackVectorTitleContainer,
  BlueprintContainer,
  DetailsInfoTitle,
  LocalizationNote,
  LocalizationNoteIcon,
  LocalizationNoteTitle,
  PretextContainer,
  PretextDescription,
  PretextTitle,
  URLLink,
} from '../styles'

const SimulationBlueprint = ({ campaignId, threat, impersonation, narrative }) => (
  <>
    <DetailsInfoTitle>
      <Protection width="16px" height="16px" fill="var(--color-text)" />
      Simulation Blueprint
    </DetailsInfoTitle>
    <div />
    <BlueprintContainer>
      <PretextContainer>
        <PretextTitle>The Threat</PretextTitle>
        <PretextDescription>{threat}</PretextDescription>
      </PretextContainer>
      <AttackVectorContainer>
        <AttackVectorTitleContainer>
          <AttackVectorTitle>Simulation Sequence</AttackVectorTitle>
          <URLLink>URL Phishing</URLLink>
        </AttackVectorTitleContainer>
        <AttackVectorSubTitleContainer style={{ marginBottom: '14px' }}>
          <AttackVectorDescription
            data-testid={`Psima_Dashboard_AttackVectorDescription_div-${campaignId}`}
          >
            <AttackVectorSubTitle>Impersonation:</AttackVectorSubTitle>
            {impersonation}
          </AttackVectorDescription>
        </AttackVectorSubTitleContainer>
        <AttackVectorSubTitleContainer>
          <AttackVectorDescription
            data-testid={`Psima_Dashboard_AttackVectorDescription_div-${campaignId}`}
          >
            <AttackVectorSubTitle>The Narrative:</AttackVectorSubTitle>
            {narrative}
          </AttackVectorDescription>
        </AttackVectorSubTitleContainer>
        <LocalizationNote>
          <LocalizationNoteIcon>
            <Language width="14px" height="14px" fill="var(--psima-source-badge-text)" />
          </LocalizationNoteIcon>
          <div>
            <LocalizationNoteTitle>Emails auto-localize per recipient</LocalizationNoteTitle>
            {/* <AttackVectorDescription>
              Each email is sent in the recipient&apos;s primary language where it strengthens the
              lure, English otherwise.
            </AttackVectorDescription> */}
          </div>
        </LocalizationNote>
      </AttackVectorContainer>
    </BlueprintContainer>
  </>
)

export default SimulationBlueprint
